import React, { useState } from 'react';
import './LandingPage.css';

function LandingPage() {
    const [formData, setFormData] = useState({
        activationCode: '',
        companyName: '',
        authorityName: '',
        phone: '05',
        email: '',
        computerCount: '',
        address: '',
        website: '',
        privacyAgreed: false,
        marketingAgreed: false,
    });

    const [errors, setErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);

    const validateActivationCode = (value) => {
        if (!value) return 'Aktivasyon Kodu gereklidir.';
        if (value.length < 3) {
            return 'Aktivasyon Kodu en az 3 karakter olmalıdır.';
        }
        return '';
    };

    const validateCompanyName = (value) => {
        if (!value) return 'Şirket Cari Unvanı gereklidir.';
        if (value.length < 3) {
            return 'Şirket Cari Unvanı en az 3 karakter olmalıdır.';
        }
        return '';
    };

    const validateAuthorityName = (value) => {
        if (!value) return 'Şirket Yetkilisi gereklidir.';
        if (value.length < 3) {
            return 'Şirket Yetkilisi en az 3 karakter olmalıdır.';
        }
        if (!/^[a-zA-ZçğıöşüÇĞİÖŞÜ\s]+$/.test(value)) {
            return 'Şirket Yetkilisi sadece harflerden oluşmalıdır.';
        }
        return '';
    };

    const validateComputerCount = (value) => {
        if (!value) return 'Bilgisayar sayısı gereklidir.';
        if (!/^\d+$/.test(value)) {
            return 'Geçerli bir sayı giriniz.';
        }
        return '';
    };

    const validateAddress = (value) => {
        if (!value) return '';
        if (value.length < 5) {
            return 'Adres en az 5 karakter olmalıdır.';
        }
        return '';
    };

    const validateWebsite = (value) => {
        if (!value) return '';
        if (!/^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/.test(value)) {
            return 'Geçerli bir web adresi giriniz (örn: www.example.com).';
        }
        return '';
    };

    const validatePhone = (value) => {
        if (!value || value === '05') return 'Telefon numarası gereklidir.';
        if (!/^05\d{9}$/.test(value.replace(/[\s\-()]/g, ''))) {
            return 'Geçerli bir telefon numarası giriniz (0533 333 33 33).';
        }
        return '';
    };

    const validateEmail = (value) => {
        if (!value) return 'E-posta gereklidir.';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            return 'Geçerli bir e-posta adresi giriniz.';
        }
        return '';
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        let newValue = value;

        if (name === 'companyName') {
            newValue = value.replace(/[^a-zA-ZçğıöşüÇĞİÖŞÜ\s0-9\-\.]/g, '');
        }

        if (name === 'authorityName') {
            newValue = value.replace(/[^a-zA-ZçğıöşüÇĞİÖŞÜ\s]/g, '');
        }

        if (name === 'computerCount') {
            newValue = value.replace(/[^\d]/g, '').slice(0, 5);
        }

        if (name === 'phone') {
            const onlyNumbers = value.replace(/\D/g, '');

            if (onlyNumbers && !onlyNumbers.startsWith('05')) {
                newValue = '05' + onlyNumbers.slice(onlyNumbers.startsWith('0') ? 1 : 0);
            } else {
                newValue = onlyNumbers;
            }

            if (newValue.length > 11) {
                newValue = newValue.slice(0, 11);
            }

            if (newValue && !newValue.startsWith('05')) {
                newValue = '05';
            }
        }

        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : newValue
        }));

        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        newErrors.activationCode = validateActivationCode(formData.activationCode);
        newErrors.companyName = validateCompanyName(formData.companyName);
        newErrors.authorityName = validateAuthorityName(formData.authorityName);
        newErrors.computerCount = validateComputerCount(formData.computerCount);
        newErrors.phone = validatePhone(formData.phone);
        newErrors.email = validateEmail(formData.email);
        newErrors.address = validateAddress(formData.address);
        newErrors.website = validateWebsite(formData.website);

        const filteredErrors = Object.fromEntries(
            Object.entries(newErrors).filter(([, value]) => value)
        );

        setErrors(filteredErrors);
        return Object.keys(filteredErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        if (!formData.privacyAgreed) {
            setErrors(prev => ({
                ...prev,
                privacyAgreed: 'Lütfen gizlilik sözleşmesini kabul ediniz.'
            }));
            return;
        }

        try {
            const response = await fetch('/allianz/api/check_policy.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    activation_code: formData.activationCode,
                    company_name: formData.companyName,
                    authority_name: formData.authorityName,
                    phone: formData.phone,
                    email: formData.email,
                    computer_count: formData.computerCount,
                    address: formData.address,
                    website: formData.website,
                }),
            });

            const data = await response.json();

            if (data.found || data.success) {
                setSubmitted(true);
                setTimeout(() => {
                    setFormData({
                        activationCode: '',
                        companyName: '',
                        authorityName: '',
                        phone: '05',
                        email: '',
                        computerCount: '',
                        address: '',
                        website: '',
                        privacyAgreed: false,
                        marketingAgreed: false,
                    });
                    setSubmitted(false);
                    setErrors({});
                }, 3000);
            } else {
                setErrors(prev => ({
                    ...prev,
                    submit: data.message || 'Bir hata oluştu.'
                }));
            }
        } catch (error) {
            setErrors(prev => ({
                ...prev,
                submit: 'Bağlantı hatası: ' + error.message
            }));
        }
    };

    if (submitted) {
        return (
            <div className="landing-page">
                <div className="success-message">
                    <h2>Başarıyla Gönderildi!</h2>
                    <p>Bilgileriniz kaydedilmiştir.</p>
                </div>
            </div>
        );
    }

    const formatPhone = (value) => {
        const onlyNumbers = value.replace(/\D/g, '');
        if (onlyNumbers.length <= 4) return onlyNumbers;
        if (onlyNumbers.length <= 7) return onlyNumbers.slice(0, 4) + ' ' + onlyNumbers.slice(4);
        if (onlyNumbers.length <= 9) return onlyNumbers.slice(0, 4) + ' ' + onlyNumbers.slice(4, 7) + ' ' + onlyNumbers.slice(7);
        return onlyNumbers.slice(0, 4) + ' ' + onlyNumbers.slice(4, 7) + ' ' + onlyNumbers.slice(7, 9) + ' ' + onlyNumbers.slice(9, 11);
    };

    return (
        <div className="landing-page">
            <div className="allianz-hero">
                <div className="allianz-content">
                    <div className='imageBackground'>
                        <img src='/allianz/slider2.png' alt="Bitdefender ve Allianz Logosu" className="hero-image" />
                        <img src='/allianz/mobilslider.jpeg' alt="Bitdefender ve Allianz Logosu" className="hero-image-mobile" />
                    </div>
                </div>
            </div>

            <div className="partnership-announcement">
                <p className="partnership-text">
                    İşletmenizin siber güvenliğini GravityZone ile sağlarken, fiziksel risklere karşı da hazırlıklı olun. 
                    Allianz Türkiye ile gerçekleştirdiğimiz iş birliği kapsamında; yangın, hırsızlık ve sel gibi risklere 
                    karşı iş yerinizi güvence altına alan Allianz İşyerim Sigortası sahiplerine, Bitdefender GravityZone 
                    Business Security korumasını ayrıcalıklı ek hizmet olarak sunuyoruz. Siz de işletmenizi 360 derece 
                    koruma kalkanına almak ve bu hizmetten ücretsiz yararlanmak için <a href="https://www.allianz.com.tr/tr_TR/urunler/ev-ve-isyeri-sigortalari/isyerim-sigortasi.html#/customer-lead-form" target="_blank" rel="noopener noreferrer" className="partnership-link">Allianz İşyerim Sigortası</a> paketlerini 
                    inceleyebilirsiniz.
                </p>
            </div>

            <div className="main-content-wrapper">
                <div className="content-left">
                    <div className="security-content">
                        <h2 className="security-title">Hepsi bir arada, basit güvenlik</h2>

                        <div className="security-visual">
                            <iframe
                                width="560"
                                height="315"
                                src="https://www.youtube.com/embed/e3iDwoDIozY"
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                                className="security-video"
                            ></iframe>
                        </div>

                        <div className="security-description">
                            <p>
                                <strong>GravityZone Business Security</strong>, kullanım kolaylığı,
                                performans ve maliyet arasındaki mükemmel dengeyi arayan
                                tüm küçük ve orta ölçekli şirketler için tasarlanmış kaynak
                                verimli bir siber güvenlik paketidir.
                            </p>

                            <p>
                                <strong>GravityZone Business Security</strong>, sadece bir işletme
                                antivirüs yazılımından çok daha fazlasıdır. İşte neden:
                            </p>

                            <div className="security-features">
                                <div className="feature-item">
                                    <span className="feature-number">1.</span>
                                    <p>Tüm kötü amaçlı yazılım türlerine karşı <strong>tam koruma</strong> sağlar:
                                        fidye yazılımları, dolandırıcılık, sıfır gün saldırıları, virüsler,
                                        casus yazılımlar, vb.</p>
                                </div>

                                <div className="feature-item">
                                    <span className="feature-number">2.</span>
                                    <p>En son tehditleri takip etmek için birden fazla makine öğrenme
                                        tekniği, davranış analizi ve çalışan işlemlerin derinlemesine
                                        incelenmesini içerir.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="form-section">
                    <div className="form-container">
                        <h3 className="form-title">GravityZone Business Security lisansınızı oluşturabilmek<br />için lütfen aşağıdaki bilgileri doldurunuz.</h3>

                        <p className="required-note">* ile işaretlenmiş alanlar zorunludur.</p>

                        {errors.submit && <div className="error-message">{errors.submit}</div>}
                        {errors.privacyAgreed && <div className="error-message">{errors.privacyAgreed}</div>}

                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Aktivasyon Kodu *</label>
                                <input
                                    type="text"
                                    name="activationCode"
                                    value={formData.activationCode}
                                    onChange={handleChange}
                                    placeholder="Aktivasyon Kodu"
                                    className={errors.activationCode ? 'input-error' : ''}
                                    maxLength="7"
                                />
                                {errors.activationCode && <span className="field-error">{errors.activationCode}</span>}
                            </div>

                            <div className="form-group">
                                <label>Şirket Cari Unvanı *</label>
                                <input
                                    type="text"
                                    name="companyName"
                                    value={formData.companyName}
                                    onChange={handleChange}
                                    placeholder="Şirket Cari Unvanı"
                                    className={errors.companyName ? 'input-error' : ''}
                                />
                                {errors.companyName && <span className="field-error">{errors.companyName}</span>}
                            </div>

                            <div className="form-group">
                                <label>Telefon *</label>
                                <input
                                    type="text"
                                    name="phone"
                                    value={formatPhone(formData.phone)}
                                    onChange={handleChange}
                                    placeholder="0533 ___ __ __"
                                    className={errors.phone ? 'input-error' : ''}
                                    maxLength="14"
                                />
                                {errors.phone && <span className="field-error">{errors.phone}</span>}
                            </div>

                            <div className="form-group">
                                <label>Şirkette Kaç Bilgisayarınız Var *</label>
                                <input
                                    type="text"
                                    name="computerCount"
                                    value={formData.computerCount}
                                    onChange={handleChange}
                                    placeholder="Bilgisayar Sayısı"
                                    className={errors.computerCount ? 'input-error' : ''}
                                />
                                {errors.computerCount && <span className="field-error">{errors.computerCount}</span>}
                            </div>

                            <div className="form-group">
                                <label>Şirket Yetkilisi *</label>
                                <input
                                    type="text"
                                    name="authorityName"
                                    value={formData.authorityName}
                                    onChange={handleChange}
                                    placeholder="Şirket Yetkilisi"
                                    className={errors.authorityName ? 'input-error' : ''}
                                />
                                {errors.authorityName && <span className="field-error">{errors.authorityName}</span>}
                            </div>

                            <div className="form-group">
                                <label>Yetkili Mail Adresi *</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="E-posta"
                                    className={errors.email ? 'input-error' : ''}
                                />
                                {errors.email && <span className="field-error">{errors.email}</span>}
                            </div>

                            <div className="form-group">
                                <label>Adres</label>
                                <input
                                    type="text"
                                    name="address"
                                    value={formData.address}
                                    onChange={handleChange}
                                    placeholder="Adres"
                                    className={errors.address ? 'input-error' : ''}
                                />
                                {errors.address && <span className="field-error">{errors.address}</span>}
                            </div>

                            <div className="form-group">
                                <label>Web Adresi</label>
                                <input
                                    type="text"
                                    name="website"
                                    value={formData.website}
                                    onChange={handleChange}
                                    placeholder="www.example.com"
                                    className={errors.website ? 'input-error' : ''}
                                />
                                {errors.website && <span className="field-error">{errors.website}</span>}
                            </div>

                            <div className="checkbox-group">
                                <label className="checkbox-label">
                                    <input
                                        type="checkbox"
                                        name="privacyAgreed"
                                        checked={formData.privacyAgreed}
                                        onChange={handleChange}
                                    />
                                    <a href="https://bitdefender.com.tr/kvkk/" target="_blank" rel="noopener noreferrer" className="privacy-link">Aydınlatma metni</a> okudum, onaylıyorum.
                                </label>
                            </div>

                            <div className="checkbox-group">
                                <label className="checkbox-label">
                                    <input
                                        type="checkbox"
                                        name="marketingAgreed"
                                        checked={formData.marketingAgreed}
                                        onChange={handleChange}
                                    />
                                    Pazarlama ve tanıtım amaçlı iletişime geçilmesine izin veriyorum.
                                </label>
                            </div>

                            <button type="submit" className="submit-button">Gönder</button>
                        </form>
                    </div>
                </div>
            </div>

            <div className="ransomware-section">
                <div className="ransomware-container">
                    <h2 className="ransomware-title">
                        GravityZone Business Security'deki<br />
                        Fidye Yazılımlarına Karşı Teknolojiler
                    </h2>
                    <p className="ransomware-subtitle">
                        Cybersecurity, sürekli olarak yenilikler ve araçlar geliştiren her iki tarafın da yer aldığı bir
                        kedi ve fare oyunudur. Saldırganların önünde olabilmek için güvenilir ve
                        otomatikleştirilmiş önleme kontrolleri uygulamanız gerekmektedir, böylece çoğu güvenlik
                        olayını önleyebilirsiniz.
                    </p>

                    <div className="ransomware-grid">
                        <div className="ransomware-card">
                            <div className="card-icon">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                                </svg>
                            </div>
                            <h3 className="card-title">Önleyici Koruma</h3>
                            <p className="card-description">
                                Fidye Yazılımı Hafifletme, etkin bir fidye yazılımı saldırısının
                                etkisini hafifletmek için tasarlanmış bir özelliktir. Herhangi bir olası yeni fidye
                                yazılımı türü dosyaları şifrelerneye çalıştığında tanır ve hedef dosyaların otomatik
                                olarak yedek kopyasını oluşturur, böylece kötü amaçlı yazılım engellenildiğinden sonra geri
                                yüklenebilir. Bitdefender, saldırıda yer alan süreçleri engeller ve iyileştirmeye başlar,
                                aynı zamanda IT yöneticilerini bilgilendirir.
                            </p>
                        </div>

                        <div className="ransomware-card">
                            <div className="card-icon">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                </svg>
                            </div>
                            <h3 className="card-title">Engelleme ve Önleme</h3>
                            <p className="card-description">
                                Fidye yazılımlarına karşı birkaç uyumlu savunma önlemi devreye girer:
                                <br /><br />
                                - Makine Öğrenme Tabanlı Kötü Amaçlı Yazılım, çalışma zamanında yeni deslenen doğru
                                bir şekilde algılar.
                                <br /><br />
                                - Gelişmiş Kötü Amaçlı Saldırı, kötü amaçlı süreçleri hızlı bir şekilde tespit ve otomatik olarak
                                sonlandırır,
                                <br /><br />
                                - Ağ Saldırı Savunması, ağ güvenlik noktaları üzerinden gelen fidye
                                yazılımı saldırılarını engeller.
                            </p>
                        </div>

                        <div className="ransomware-card">
                            <div className="card-icon">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M12 2v20M2 12h20" />
                                    <circle cx="12" cy="12" r="10" />
                                </svg>
                            </div>
                            <h3 className="card-title">Gerçek Zamanlı İzleme</h3>
                            <p className="card-description">
                                GravityZone'nin çok sayıda risk azaltma teknolojisi, sistem ve
                                uygulama zaafiyetlerini ve davranışlarını sömüren fidye yazılımı
                                saldırlarını engellemek için güçlü ve yanlış
                                yapılandırılmışlarını önler.
                                <br /><br />
                                Benzersiz İnsan Riski Analitiği modülü, riski belirlenecek
                                eylemlerini ve davranışlarını sömüren fidye yazılımı
                                saldırılarını engeller.
                            </p>
                        </div>

                        <div className="ransomware-card">
                            <div className="card-icon">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                                    <path d="M9 12l2 2 4-4" />
                                </svg>
                            </div>
                            <h3 className="card-title">Risk Azaltma</h3>
                            <p className="card-description">
                                GravityZone'ün çok sayıda risk azaltma teknolojisi, risklı kullanıcı
                                eylemlerini ve davranış zaafiyetlerini organizasyonları fidye yazılımı
                                saldırılarına karşı korumak için güçlü ve yanlış. Benzersiz Analiz modülü, risk kullanımı
                                saldırma zaafiyeti, davranış analizi ve çalışan işlemlerin derinlemesine
                                incelendiği fidye yazılımı saldırılarını ve davranışlarını
                                sömüren fidye yazılımı saldırılarını engeller.
                            </p>
                        </div>
                    </div>

                    <div className="dots-decoration"></div>
                </div>
            </div>

            <div className="industry-awards-section">
                <div className="industry-awards-container">
                    <div className="industry-awards-header">
                        <div>
                            <h2 className="industry-awards-title">Endüstri Övgüleri</h2>
                            <p className="industry-awards-subtitle">
                                Bitdefender, endüstri ödüllerini sık sık kazanan ve bağımsız test kuruluşları ve endüstri
                                analist firmaları tarafından siber güvenlikte lider olarak tanınmaktadır.
                            </p>
                        </div>
                        <a href="https://bitdefender.com.tr/sirket/oduller/" target="_blank" rel="noopener noreferrer" className="view-all-link">
                            Hepsini gör →
                        </a>
                    </div>

                    <div className="industry-awards-logos">
                        <div className="award-logo">
                            <img src="/allianz/banner1.png" alt="Gartner Peer Insights" />
                        </div>
                        <div className="award-logo">
                            <img src="/allianz/banner2.jpeg" alt="MITRE ATT&CK" />
                        </div>
                        <div className="award-logo">
                            <img src="/allianz/banner3.jpeg" alt="AV Test" />
                        </div>
                        <div className="award-logo">
                            <img src="/allianz/banner4.png" alt="AV Comparatives" />
                        </div>
                        <div className="award-logo">
                            <img src="/allianz/banner5.png" alt="CRN Edge 100" />
                        </div>
                        <div className="award-logo">
                            <img src="/allianz/banner6.png" alt="The Radicati Group" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="cta-section">
                <h2>Sorularınız mı var?</h2>
                <p>Size yardımcı olmak için buradayız!</p>
                <a href="https://bitdefender.com.tr/iletisim/" target="_blank" rel="noopener noreferrer" className="cta-button">
                    Bizimle İletişime Geçin!
                </a>
            </div>

            <div className="stats-section">
                <div className="stats-content">
                    <p className="stats-label">DÜNYA ÇAPINDA</p>
                    <h2 className="stats-number">500 MİLYON</h2>
                    <h3 className="stats-title">SİSTEMİN KORUNMASI</h3>
                    <p className="stats-description">YENİLİK VE GÜVENLİK İÇİN BİTDEFENDER'İN KALBİNDE DERİN BİR TUTKU VAR</p>
                </div>
            </div>

            <footer className="footer-section">
                <div className="footer-container">
                    <div className="footer-content">
                        <div className="footer-info">
                            <h2 className="footer-title"><a href='https://bitdefender.com.tr/' target='_blank'><img src='/allianz/bitdefender-logo.svg'></img></a></h2>
                            <div className="footer-links">
                                <a href="https://bitdefender.com.tr/gizlilik-politikasi/" target="_blank" rel="noopener noreferrer">Gizlilik Politikası</a>
                                <span className="link-separator">|</span>
                                <a href="https://bitdefender.com.tr/kvkk/" target="_blank" rel="noopener noreferrer">Aydınlatma Metni</a>
                                <span className="link-separator">|</span>
                                <a href="https://bitdefender.com.tr/cerez-politikasi/" target="_blank" rel="noopener noreferrer">Çerez Politikası</a>
                                <span className="link-separator">|</span>
                                <a href="https://bitdefender.com.tr/bilgi-talep-formu/" target="_blank" rel="noopener noreferrer">Bilgi Talep Formu</a>
                                <span className="link-separator">|</span>
                                <a href="https://bitdefender.com.tr/iletisim/" target="_blank" rel="noopener noreferrer">İletişim</a>
                            </div>
                            <p className="footer-copyright">Copyright © 1997 - 2026 Bitdefender. Hak Saklıdır</p>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default LandingPage;
